import { PaymentMethod } from "@/apps/shared/proposal/core/domain/model/PaymentMethod";
import { Modifier } from "@/apps/shared/proposal/core/domain/model/Modifier";

export class ShippingMethod {
  id: string;
  channel: string;
  type: string;
  description: string;
  modifier: Modifier | null;
  paymentMethods: PaymentMethod[];
  availableCountries: string[];

  constructor(
    id: string,
    channel: string,
    type: string,
    description: string,
    modifier: Modifier | null,
    paymentMethods: PaymentMethod[],
    availableCountries: string[]
  ) {
    this.id = id;
    this.channel = channel;
    this.type = type;
    this.description = description;
    this.modifier = modifier;
    this.paymentMethods = paymentMethods ?? [];
    this.availableCountries = availableCountries;
  }

  isWebToStore(): boolean {
    return "web" === this.channel && ["drop", "drop_label"].includes(this.type);
  }

  isStoreDrop(): boolean {
    return "store" === this.channel && ["drop", "drop_label"].includes(this.type);
  }
}
